<div class="container">
  <div class="modal-header mb-4">
    <h5 *ngIf="!data">{{ 'map.sidebar.psa.mitigating_action.title_new' | translate }}</h5>
    <h5 *ngIf="data">{{ 'map.sidebar.psa.mitigating_action.title_edit' | translate }} {{ data.nome }}</h5>
  </div>

  <div class="modal-body">
    <form [formGroup]="actionForm" (ngSubmit)="onSave()">
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.mitigating_action.name_label' | translate }}</mat-label>
              <textarea
                matInput
                formControlName="nome"
                placeholder="{{ 'map.sidebar.psa.mitigating_action.name_label' | translate }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="10"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.mitigating_action.description_label' | translate }}</mat-label>
              <textarea
                matInput
                formControlName="descrizione"
                placeholder="{{ 'map.sidebar.psa.mitigating_action.description_label' | translate }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="10"
              ></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'map.sidebar.psa.mitigating_action.search_label' | translate }}</mat-label>

              <input
                #myInput
                type="text"
                placeholder="{{ 'map.sidebar.psa.mitigating_action.search_events' | translate }}"
                matInput
                (input)="onInput()"
                [(ngModel)]="inputValue"
                [ngModelOptions]="{ standalone: true }"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                (optionSelected)="onOptionSelected($event.option.value)"
              >
                <mat-option *ngFor="let option of riskEventsFiltered" [value]="option">
                  <div
                    class="d-flex flex-column align-items-start justify-content-start gap-1"
                    [title]="option.nome + ' - ' + option.descrizione"
                  >
                    <div>
                      <b>{{ option.nome }}</b
                      ><span class="font-09rem"> - {{ option.descrizione }}</span>
                    </div>
                    <div class="font-09rem">
                      {{ option.tipologia }}
                    </div>
                  </div>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <span class="warning-label" *ngIf="riskEventsFiltered && riskEventsFiltered.length === 0">
              <mat-icon class="me-2">warning_amber</mat-icon> {{ 'map.sidebar.psa.no_elements_found' | translate }}
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 scrollable-div">
            <mat-list>
              <mat-list-item *ngFor="let risk of associatedListEvents">
                <mat-icon
                  color="warn"
                  (click)="removeEvent(risk)"
                  matTooltip="{{ 'map.sidebar.psa.mitigating_action.delete_tooltip' | translate }}"
                  matListItemIcon
                  >delete</mat-icon
                >
                <div matListItemTitle>{{ risk.nome }}</div>
                <div matListItemLine>{{ risk.tipologia }}</div>
                <!-- <button
                  mat-icon-button
                  color="warn"
                  (click)="removeEvent(risk)"
                  matTooltip="{{ 'map.sidebar.psa.mitigating_action.delete_tooltip' | translate }}"
                >
                  <mat-icon>delete</mat-icon>
                </button>
                <div class="event-info">
                  <span>{{ risk.nome }}</span>
                  <small>{{ risk.tipologia }}</small>
                </div> -->
              </mat-list-item>
            </mat-list>
          </div>
        </div>
      </div>

      <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="onCancel()">
          {{ 'map.sidebar.psa.mitigating_action.button_cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" type="submit" [disabled]="actionForm.invalid">
          {{ 'map.sidebar.psa.mitigating_action.button_save' | translate }}
        </button>
      </mat-dialog-actions>
    </form>
  </div>
</div>
